import type { ComponentChildren } from 'preact';
import { describeRoute, hrefOf } from '../nav';
import { Icon } from './Icon';

/**
 * "← Back to <where you came from>" for pages entered with a `from=` context (see withFrom()).
 * Renders nothing when there is no usable origin, so cold links look normal.
 */
export function ReturnStrip({ query, note }: { query: URLSearchParams; note?: ComponentChildren }) {
  const from = query.get('from');
  const label = from ? describeRoute(from) : undefined;
  if (!from || !label) return null;
  return (
    <div class="return-strip">
      <a class="btn btn-sm btn-ghost" href={hrefOf(from)}><Icon name="arrowLeft" /> Back to {label}</a>
      {note && <span class="small muted">{note}</span>}
    </div>
  );
}
